/*
  全局「复制到剪贴板」按钮。
  作用于任何带 data-glce-copy="要复制的内容" 的元素，用事件委托挂在 document 上，
  所以对后插入的 DOM 也生效 —— 包括 Shopify 后台页面正文里手写的 HTML，
  那里的 <script> 会被编辑器剥掉，只能靠主题侧接管。

  按钮结构（.glce-copy__icon 和 .glce-copy__check 由 CSS 控制显隐）：
    <button class="glce-copy" data-glce-copy="值">
      <svg class="glce-copy__icon">…</svg>
      <svg class="glce-copy__check">…</svg>
    </button>
*/
(function () {
  'use strict';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // 降级：老浏览器 / 非安全上下文
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.top = '-1000px';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(field);
      ok ? resolve() : reject();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-glce-copy]');
    if (!button) return;

    event.preventDefault();
    var value = button.getAttribute('data-glce-copy');
    if (!value) return;

    copyText(value).then(
      function () {
        button.classList.add('is-copied');
        button.setAttribute('aria-label', 'Copied');
        button.setAttribute('title', 'Copied');
        clearTimeout(button._glceTimer);
        button._glceTimer = setTimeout(function () {
          button.classList.remove('is-copied');
          button.setAttribute('aria-label', 'Copy ' + value);
          button.setAttribute('title', 'Copy');
        }, 2000);
      },
      function () {
        // 复制失败时不给假的成功反馈；内容本身仍可手动选中
      }
    );
  });
})();

/*
  页面正文里的宽表格在手机上会被挤成几十像素宽的列，文字互相重叠。
  这里给每个表格包一层可横向滚动的容器 —— 和上面的复制按钮同理，
  后台页面正文里的 <script> 会被剥掉，只能由主题侧接管。
*/
(function () {
  function wrapTables(root) {
    (root || document).querySelectorAll('.rte table').forEach(function (table) {
      var parent = table.parentElement;
      if (parent && parent.classList.contains('glce-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'glce-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wrapTables(); });
  } else {
    wrapTables();
  }
  /* 主题编辑器里重载 section 后重新处理 */
  document.addEventListener('shopify:section:load', function (e) { wrapTables(e.target); });
})();
